'use es6';

import { Alert } from 'foundations-components/transitional/components/Alert';
import { H4 } from 'foundations-components/transitional/components/H4';
import { HelpLink } from 'foundations-components/transitional/components/HelpLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const trackTooltipInteraction = (evt, isUserJitad) => {
  if (evt.target.value && !isUserJitad) {
    UsageTracker.trackEditorInteraction({
      action: 'Approvals Action',
      event: 'viewContentEditorAccessRequestTooltip'
    });
  }
};
const ReadOnlyTestVariantWarning = ({
  isAbTest,
  isMabTest,
  isUserJitad
}) => {
  let langSubkey;
  if (isAbTest) {
    langSubkey = 'abTest';
  } else if (isMabTest) {
    langSubkey = 'mabTest';
  } else {
    throw new Error('ReadOnlyTestVariantWarning can only be rendered when isAbTest or isMabTest is true');
  }
  return /*#__PURE__*/_jsxs(Alert, {
    type: "warning",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `readOnlyTestVariantWarning.${langSubkey}.title`
    }), /*#__PURE__*/_jsx(HelpLink, {
      defaultOpen: false,
      showCloseButton: true,
      onOpenChange: evt => trackTooltipInteraction(evt, isUserJitad),
      content: {
        header: /*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `readOnlyTestVariantWarning.${langSubkey}.helpPopoverHeader`
          })
        }),
        body: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `readOnlyTestVariantWarning.${langSubkey}.helpPopoverBody`
          })
        })
      },
      marginInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `readOnlyTestVariantWarning.${langSubkey}.helpPopoverLink`
      })
    })]
  });
};
export default ReadOnlyTestVariantWarning;